module.exports = __webpack_public_path__ + "7953236fdeb362a894662617e1004ac8.png";